<template>
  <a
    :href="href"
    rel="noopener noreferrer"
    target="_blank"
  >
    <slot v-if="$slots.default" />
    <span v-else>
      {{ href }}
    </span>
  </a>
</template>

<script>
/**
 * Motivation: target="_blank" can introduce vulnerabilities with external links.
 * Reverse tabnabbing is an attack where a page linked from the target page
 * is able to rewrite that page, for example to replace it with a phishing site.
 * @see https://owasp.org/www-community/attacks/Reverse_Tabnabbing
 */

export default {
  name: 'LinkExternal',

  props: {
    href: {
      type: String,
      required: true,
    },
  },
};
</script>
